<template>
  <v-dialog
    eager
    v-model="dialog"
    persistent
    hide-overlay
    :transition="''"
    max-width="400"
  >
    <div :class="dialogClass">
      <!-- v-draggable="draggableModel" -->
      <v-card
        class="card-collapsable"
        :class="{
          'is-not-collapsed': !isCollapsed,
          'is-collapsed': isCollapsed,
          'animation-shake': isCollapsed,
          isMobile: is_mobile,
        }"
      >
        <div class="header touchable" :class="headerClass" role="tab">
          <div class="always-visible d-flex justify-center align-center">
            <slot name="visible"></slot>
          </div>
          <div class="title">
            <slot name="title"></slot>
          </div>
          <v-btn fab small depressed class="icon-collapse mr-2">
            <v-icon style="transform: scaleX(-1)">pin_invoke</v-icon>
          </v-btn>

          <div class="overlay" @click.prevent="toggle"></div>
        </div>

        <div class="body">
          <slot name="body"></slot>
        </div>

        <div class="actions">
          <v-divider></v-divider>
          <slot name="actions"></slot>
        </div>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
// import { Draggable } from "draggable-vue-directive";
import Vuex from "vuex";
export default {
  name: "CardCollapsable",
  // directives: {
  //   Draggable,
  // },

  data() {
    return {
      isCollapsed: false,
      // draggableModel: {
      //   initialPosition: { top: 50, left: 10 },
      //   onDragStart: this.onDragStarted,
      //   onDragEnd: this.onDragEnded,
      //   dragged: false,
      //   _top: null,
      //   _left: null,
      //   // stopDragging: false,
      //   // resetInitialPos: false,
      // },
    };
  },

  props: {
    headerClass: {
      type: [String, Object],
      required: true,
      default: "",
    },
    dialogClass: {
      type: String,
      required: true,
      default: "",
    },
    dialogProp: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    isCollapsed(val) {
      this.$emit("changeCollapse", val);
    },
    dialog(val) {
      if(val){
        this.isCollapsed = false;
      }
    },
  },
  computed: {
    dialog() {
      return this.dialogProp;
    },
    ...Vuex.mapGetters(["is_mobile"]),
  },

  methods: {
    // IMPORTANTE:
    // onDragStarted() -> onDragEnded() -> toggle()
    // (questo è l'ordine al click che ho ravvisato io nei test)

    // onDragStarted(positionDiff, absolutePosition, event) {
    //   console.log("onDragStarted");
    //   // mantieni memoria della posizione iniziale (srrve poi in onDragEnded)
    //   this.draggableModel._top = absolutePosition.top;
    //   this.draggableModel._left = absolutePosition.left;
    //   // this.setDragInitialPos(absolutePosition);
    //   // this.updateDragModel();
    // },
    // onDragEnded(positionDiff, absolutePosition, event) {
    //   console.log("onDragEnded");

    //   // set dragged
    //   if (
    //     this.draggableModel._top == absolutePosition.top &&
    //     this.draggableModel._left == absolutePosition.left
    //   ) {
    //     this.draggableModel.dragged = false;
    //   } else {
    //     this.draggableModel.dragged = true;
    //   }

    // revert dragged if it was not collapsed
    //   if (!this.isCollapsed) {
    //     this.draggableModel.initialPosition = {
    //       left: this.draggableModel._left,
    //       top: this.draggableModel._top,
    //     };
    //     this.draggableModel.resetInitialPos = true;
    //   } else {
    //     this.draggableModel.resetInitialPos = false;
    //   }
    //},
    // updateDragModel() {
    //   // console.log("this.isCollapsed", this.isCollapsed);
    //   if (this.isCollapsed) {
    //     // this.draggableModel.resetInitialPos = true;
    //     // this.draggableModel.initialPosition = { left: 5, top: 50 };
    //     //this.draggableModel.stopDragging = true;
    //   } else {
    //     // this.draggableModel.resetInitialPos = false;
    //     //this.draggableModel.stopDragging = false;
    //   }
    // },

    // setDragInitialPos(absolutePosition) {
    //   if (
    //     !this.draggableModel.initialPosition ||
    //     (this.draggableModel.initialPosition.left == 0 &&
    //       this.draggableModel.initialPosition.top == 0)
    //   ) {
    //     console.log('InitialPos set')
    //     this.draggableModel.initialPosition = {
    //       left: absolutePosition.left,
    //       top: absolutePosition.top,
    //     };
    //   }
    // },

    toggle() {
      // se è stato trascinato, non fare il collapse
      // if (this.draggableModel.dragged) return;
      // console.log("toggled");
      this.isCollapsed = !this.isCollapsed;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../main.scss";

.card-collapsable {
  .header {
    position: relative;
    display: flex;
    align-items: center;
    padding: 10px;
    justify-content: space-between;
    cursor: pointer;

    .overlay {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      &:hover {
        background: rgb(0 0 0 / 5%);
      }
    }
  }
  .title {
    padding-left: 10px;
    font-size: $font-size-title;
    line-height: 20px;
    font-weight: normal;
  }

  .icon-collapse {
    background-color: rgba(0, 0, 0, 0.12);
    color: white;
  }

  // servono per sovrascrivere il plugin draggable
  // &.is-not-collapsed {
  //   position: relative !important;
  //   left: 0 !important;
  //   top: 0 !important;
  // }

  &.is-collapsed {
    position: fixed !important;
    left: 26%;
    top: 70px;
    border-radius: 50% !important;
    &.isMobile {
      top: 60px;
      left: 5px;
    }

    .always-visible {
      min-width: 42px;
      min-height: 42px;
    }
    .header {
      border-radius: 50% !important;
      &::before {
        content: none;
      }
    }
    .overlay {
      border-radius: 50% !important;
    }
    .header .title,
    .icon-collapse,
    .body,
    .actions {
      display: none;
    }
  }
}

</style>

